import { all, put, call, takeEvery } from 'redux-saga/effects'

import { getProperties } from '../api'
import { apiError, showPopup } from '../helpers'
import { captureException } from '../helpers/Sentry'
import { logout, LOGOUT } from './auth'

// import { initializeContracts } from './contracts'
import { fetchStatesSaga } from './states'

const initialState = {
  entities: [],
  selectedPropertyId: '',
  loading: false,
  error: null,
  loaded: false
}

export const moduleName = 'properties'
export const FETCH_PROPERTIES_REQUEST = `${moduleName}/FETCH_PROPERTIES_REQUEST`
export const FETCH_PROPERTIES_SUCCESS = `${moduleName}/FETCH_PROPERTIES_SUCCESS`
export const FETCH_PROPERTIES_FAIL = `${moduleName}/FETCH_PROPERTIES_FAIL`
export const SET_ACTIVE_PROPERTY = `${moduleName}/SET_ACTIVE_PROPERTY`

export default function reducer(state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case FETCH_PROPERTIES_REQUEST:
      return { ...state, loading: true, loaded: false, error: null }
    case FETCH_PROPERTIES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        ...payload
        // entities: payload
      }
    case FETCH_PROPERTIES_FAIL:
      return { ...state, loading: false, error: payload }
    case SET_ACTIVE_PROPERTY: {
      return { ...state, selectedPropertyId: payload }
    }

    case LOGOUT:
      return { ...initialState }

    default:
      return state
  }
}

export function fetchProperties(options) {
  return {
    type: FETCH_PROPERTIES_REQUEST,
    options
  }
}

export function setActiveProperty(propertyId = null, fetchInteractions = true) {
  return {
    type: SET_ACTIVE_PROPERTY,
    payload: propertyId,
    fetchInteractions
  }
}

export const setActivePropertySaga = function*(action) {
  const { fetchInteractions } = action
  yield call(fetchStatesSaga, fetchInteractions)
}

export const fetchPropertiesSaga = function*() {
  try {
    const res = yield call(getProperties)

    const response = res.map(x=>({
      ...x,
      property_id: x.id
    }))

    const payload = {
      entities: response
    }

    if (response.length === 1) {
      payload.selectedPropertyId = response[0].property_id
    }

    yield put({
      type: FETCH_PROPERTIES_SUCCESS,
      payload
    })
  } catch (e) {
    yield put(showPopup(e))
    if (e instanceof apiError) {
      const { code, message } = e
      yield put({
        type: FETCH_PROPERTIES_FAIL,
        payload: {
          code,
          message
        }
      })
      if (code === 2) {
        yield put(logout())
      }
    } else {
      yield put({
        type: FETCH_PROPERTIES_FAIL,
        payload: {
          code: 0,
          message: 'look what I got!'
        }
      })
      // TODO call some cross-screen error
      captureException(e)
    }
  }
}

export const saga = function*() {
  yield all([
    takeEvery(FETCH_PROPERTIES_REQUEST, fetchPropertiesSaga),
    takeEvery(SET_ACTIVE_PROPERTY, setActivePropertySaga)
  ])
}
